import { useMemo } from "react"
import { useSelector } from "react-redux"
import fp from "lodash/fp"

import { selectCurrentOrgId } from "features/store/orgSlice"
import { useOrgDeviceStatusesQuery } from "features/api"
import { STATUSES_TIME } from "helpers/utils/constants"
import type { DeviceStatus, DeviceStatusesById } from "types/device.types"

interface useOrgDeviceStatusesReturn {
  isSuccess: boolean
  isError: boolean
  isFetching: boolean
  isLoading: boolean
  deviceStatuses: DeviceStatus[] | undefined
  statusesById: DeviceStatusesById
}

const useOrgDeviceStatuses = (): useOrgDeviceStatusesReturn => {
  const orgId = useSelector(selectCurrentOrgId)
  const {
    currentData: deviceStatuses,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useOrgDeviceStatusesQuery(
    {
      orgId: orgId as number,
    },
    {
      skip: !orgId,
      pollingInterval: STATUSES_TIME,
    },
  )

  const statusesById = useMemo(
    () => fp.indexBy("less_id", deviceStatuses),
    [deviceStatuses],
  )

  return {
    deviceStatuses,
    statusesById,
    isError,
    isSuccess,
    isFetching,
    isLoading,
  }
}

export default useOrgDeviceStatuses
